import React from 'react';
import useLocale from '@/hooks/useLocale';
import type {
  GatorProtectUpgradeCycleLocale,
  LocaleWithGatorProtectUpgradeCycle,
} from '../../../gatorProtect.types';
import * as Styles from '../ProtectionCard.styles';
import {
  ProtectionCardBody,
  ProtectionCardShield,
  ProtectionCardTextBlock,
  ProtectionCardActions,
  ProtectionCardButton,
  ProtectionCardMonarx,
} from '../ProtectionCardCompound';

export const UPGRADE_CYCLE_PROTECTION_CARD_TYPE = 'upgradeCycle' as const;
export type UpgradeCycleProtectionCardType = typeof UPGRADE_CYCLE_PROTECTION_CARD_TYPE;

export type UpgradeCycleVariantProps = {
  testId?: string;
  discountPercent: number;
  isButtonLoading?: boolean;
  onButtonClick?: () => void;
};

const UpgradeCycleVariant: React.FC<UpgradeCycleVariantProps> = ({
  testId = 'protection-card',
  discountPercent,
  isButtonLoading = false,
  onButtonClick,
}) => {
  const { gatorProtect } = useLocale() as LocaleWithGatorProtectUpgradeCycle;
  const raw = gatorProtect?.summary?.protectionCard?.upgradeCycle;

  if (
    !raw
    || typeof raw.getDescriptionHtml !== 'function'
    || typeof raw.getActionLabel !== 'function'
  ) {
    return null;
  }

  const block = raw as GatorProtectUpgradeCycleLocale;

  const descriptionHtml = block.getDescriptionHtml(discountPercent);

  const actionsTestId = `${testId}__actions`;

  return (
    <Styles.InverseCard data-component="ProtectionCardCompound" data-testid={testId}>
      <ProtectionCardBody>
        <ProtectionCardShield title={block.title} />
        <ProtectionCardTextBlock>
          <Styles.InverseTitle>{block.title}</Styles.InverseTitle>
          {Boolean(descriptionHtml) && (
            <Styles.InverseDescription
              dangerouslySetInnerHTML={{ __html: descriptionHtml }}
            />
          )}
          <ProtectionCardActions actionsTestId={actionsTestId}>
            <ProtectionCardButton
              variant="inverse"
              hasMultipleButtons={false}
              onClick={onButtonClick}
              testId={`${testId}__action-subscribeAnnualWithDiscount`}
              loading={isButtonLoading}
            >
              {block.getActionLabel(discountPercent)}
            </ProtectionCardButton>
          </ProtectionCardActions>
        </ProtectionCardTextBlock>
      </ProtectionCardBody>
      <ProtectionCardMonarx title={block.title} />
    </Styles.InverseCard>
  );
};

export default UpgradeCycleVariant;
